{
  "version": 1,
  "asset_id": "36baa9b0-c7e9-41e2-8f5d-e40459cbe533",
  "project_id": "9f205a2e-8c62-436c-9ba0-eb8567773752",
  "url": "/__l5e/assets-v1/36baa9b0-c7e9-41e2-8f5d-e40459cbe533/how-it-works-hero-960.avif",
  "r2_key": "a/v1/9f205a2e-8c62-436c-9ba0-eb8567773752/36baa9b0-c7e9-41e2-8f5d-e40459cbe533/how-it-works-hero-960.avif",
  "original_filename": "how-it-works-hero-960.avif",
  "size": 35946,
  "content_type": "image/avif",
  "created_at": "2026-07-22T22:51:21Z"
}
